(() => {
  if (customElements.get('jannela-cart-delivery')) return;
  class JannelaCartDelivery extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-standard-delivery')) return;
      this.updateDelivery = () => {
        const berlin = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
        });
        const parts = Object.fromEntries(berlin.formatToParts(new Date()).map(part => [part.type, part.value]));
        const day = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
        const days = [];
        while (days.length < 3) {
          day.setUTCDate(day.getUTCDate() + 1);
          if (day.getUTCDay() !== 0) days.push(new Date(day));
        }
        const format = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', day: '2-digit', month: '2-digit' });
        this.textContent = `${this.dataset.estimateLabel} ${format.format(days[0])} – ${format.format(days[2])}`;
      };
      this.onVisible = () => { if (!document.hidden) this.updateDelivery(); };
      this.drawer = this.closest('drawer-component');
      this.updateDelivery();
      this.drawer?.addEventListener('open', this.updateDelivery);
      window.addEventListener('pageshow', this.updateDelivery);
      document.addEventListener('visibilitychange', this.onVisible);
    }
    disconnectedCallback() {
      this.drawer?.removeEventListener('open', this.updateDelivery);
      window.removeEventListener('pageshow', this.updateDelivery);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
  }
  customElements.define('jannela-cart-delivery', JannelaCartDelivery);
})();
